export default "__VITE_ASSET__8AnrkHLr__"